import React, { useState, useRef } from 'react';
import { IconCheck, IconChevronDown, IconX } from '@tabler/icons-react';
import useClickOutside from 'lib/hooks/useClickOutside';

const InputSelected = ({
  dataOption = [],
  selected,
  setSelected,
  label,
  required = false,
  width,
  withClear = false,
  showClearOption = false,
  onClear,
  iconComponent: IconComponent,
  disabled = false,
  placeholder,
}) => {
  const dropdownRef = useRef(null);
  const [showFilterDate, setShowFilterDate] = useState(false);

  useClickOutside(dropdownRef, () => setShowFilterDate(false));

  const handleSetFilterDate = (item) => {
    if (disabled) return;
    setSelected(item);
    setShowFilterDate(false);
  };

  const handleToggleDropdown = () => {
    if (!disabled) setShowFilterDate((prev) => !prev);
  };

  const handleClear = () => {
    setSelected(null);
    setShowFilterDate(false);
    if (onClear) onClear(); // Trigger callback
  };

  return (
    <div className="flex flex-col gap-1">
      {/* Label */}
      <div className="flex items-center justify-between gap-1">
        {label && <label className="block text-sm font-medium leading-6">{label || 'Type'}</label>}
        {required && <label className="block text-xs font-light leading-6">(required)</label>}
      </div>

      {/* Input Wrapper */}
      <div
        className={`${
          width ? width : 'w-[200px]'
        } relative flex flex-row gap-2 items-center bg-white rounded-lg`}
        ref={dropdownRef}>
        {/* Selected Box */}
        <div
          onClick={handleToggleDropdown}
          className={`w-full flex flex-row justify-between py-1.5 px-3 items-center gap-2 min-h-[36px] rounded-xl border-0 shadow-sm 
            ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-50' : 'cursor-pointer bg-white'}
          `}>
          {selected ? (
            <span className="font-semibold text-kin-text">{selected.name}</span>
          ) : (
            <span className="text-gray-400">
              {placeholder ? placeholder : `Pick ${label ? label.toLowerCase() : 'type'}`}
            </span>
          )}
          <div>
            {IconComponent ? (
              <IconComponent className="text-gray-500 w-5 h-5" />
            ) : (
              <IconChevronDown className="text-gray-500 w-5 h-5" />
            )}
          </div>
        </div>

        {/* Clear Button (icon X di kanan) */}
        {withClear && selected && !disabled && (
          <div
            className="cursor-pointer ring-1 ring-inset ring-gray-300 p-1.5 rounded-md hover:bg-gray-50"
            onClick={handleClear}>
            <IconX className="text-gray-500 w-5 h-5" />
          </div>
        )}

        {/* Dropdown Options */}
        {!disabled && showFilterDate && (
          <div className={`${width ? width : 'w-[200px]'} absolute top-[40px] z-10`}>
            <div className="bg-white flex flex-col py-1 shadow-lg rounded-md max-h-[200px] overflow-y-auto">
              {/* Clear option in dropdown */}
              {showClearOption && selected && (
                <div
                  onClick={handleClear}
                  className="text-gray-400 cursor-pointer px-4 py-2 hover:text-white hover:bg-primary-main border-b">
                  Clear Selection
                </div>
              )}

              {dataOption.length > 0 ? (
                dataOption.map((item, idx) => {
                  const activeItem = selected?.name === item.name;
                  return (
                    <div
                      key={idx}
                      onClick={() => handleSetFilterDate(item)}
                      className={`${
                        activeItem
                          ? 'font-bold bg-primary-main text-white'
                          : 'text-kin-text font-normal'
                      } cursor-pointer px-4 py-2 flex flex-row items-center justify-start hover:bg-primary-main hover:text-white`}>
                      {item.name}
                      {activeItem && <IconCheck className="ml-1 w-4 h-4" />}
                    </div>
                  );
                })
              ) : (
                <div className="px-4 py-2 text-gray-400 text-sm">No options available</div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InputSelected;
